module.exports = __webpack_public_path__ + "img/whiteCursorIcon.7f064558.svg";